/*
 * Copyright (c) Nexign, JSC, 2019-2020.
 */
/**
 *
 * @author Fedorov Maxim
 * @author Anton Panasenko
 * @author Yakov Gushchin
 * @author Aleksandr Perkhunov
 * @version 1.4.0
 * @since 1.0.1
 */

import { icons } from '../../../../../../assets';
import { FlexColumnMiddleStyled } from '../../../../../../components/common/Block/Flexbox';
import { ImgStyled } from '../../../../../../components/common/Block/Img';
import { LayoutStyled } from '../../../../../../components/common/Block/Layout';
import { WidgetHelpTitleStyled } from '../../styled/WidgetHelpStyled';
import {
    WidgetOrderInquiriesEmptyContainer,
    WidgetOrderInquiriesEmptyLabelTipsStyled,
} from '../styled/widgetOrderInquiriesStyled';

export interface IWidgetOrderInquiriesEmpty {
    helpText: string;
    title: string;
}

const WidgetOrdersEmpty = (props: IWidgetOrderInquiriesEmpty) => {
    const { title, helpText } = props;
    return (
        <FlexColumnMiddleStyled>
            <WidgetOrderInquiriesEmptyContainer>
                <ImgStyled
                    className="medium"
                    src={icons.transactionMediumIcon}
                />
            </WidgetOrderInquiriesEmptyContainer>
            <LayoutStyled className="mb-1 mt-4 mx-auto t-center" width='270px'>
                <WidgetHelpTitleStyled>
                    {title}
                </WidgetHelpTitleStyled>
            </LayoutStyled>
            <WidgetOrderInquiriesEmptyLabelTipsStyled>
                {helpText}
            </WidgetOrderInquiriesEmptyLabelTipsStyled>
        </FlexColumnMiddleStyled>
    );
};

export default WidgetOrdersEmpty;
